// extracted by mini-css-extract-plugin
export default {"brandPromo":"WG-z","carousel":"XG-z"};